import React from "react";
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

const data = [
  { name: "Segregating", value: 10 },
  { name: "Not segregating", value: 3 },
];

const COLORS = ["#76C7C0", "#BEBEBE"]; // Light teal and grey

const SocietySegregationChart: React.FC = () => {
  return (
    <div style={{ textAlign: "center" }}>
      <h3 className="text-center font-semibold text-blue-900 mb-2">
        Societies segregating (10/13)
      </h3>
      <ResponsiveContainer width="100%" height={300}>
        <PieChart>
          <Pie
            data={data}
            dataKey="value"
            nameKey="name"
            cx="50%"
            cy="50%"
            outerRadius={100}
            startAngle={90}
            endAngle={-270}
          >
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index]} />
            ))}
          </Pie>
          <Tooltip />
          <Legend verticalAlign="bottom" />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};

export default SocietySegregationChart;
